import { OfferResponse } from 'logic/api-models/api-models';

interface AdPlaceHolder {
  isAd: boolean;
}

export const isAdPlaceHolder = (
  item: OfferResponse | AdPlaceHolder | undefined
): item is AdPlaceHolder => !!(item as AdPlaceHolder | undefined)?.isAd;

const adPlaceHolder: AdPlaceHolder = { isAd: true };

export const zipAdsWithOffers = (offers: Array<OfferResponse | undefined> | undefined) =>
  offers?.reduce((result, offer, index) => {
    const isLast = index === offers.length - 1;
    const shouldAddAd = (index - 1) % 5 === 0 && !isLast;
    const ad = shouldAddAd ? [adPlaceHolder] : [];

    return [...result, offer, ...ad];
  }, new Array<OfferResponse | AdPlaceHolder | undefined>());
